import app from 'flarum/forum/app';
import {extend, override} from "flarum/common/extend";
import HeaderSecondary from "flarum/forum/components/HeaderSecondary";
import Link from "flarum/common/components/Link";

app.initializers.add('dnw-sso', () => {
  extend(HeaderSecondary.prototype, 'items', function(items) {
    if (app.session.user) {
      return;
    }


    const baseUrl = app.forum.attribute('dnw-sso.auth_url');
    const current = app.history.getCurrent();

    const path = current.url;
    const pathEncoded = btoa(path);

    const clientId = app.forum.attribute('dnw-sso.client_id');
    const url = baseUrl + '?state=' + pathEncoded + '&client_id=' + clientId;

    items.add('dnw-sso-button', Link.component({
      className: 'Button Button--link',
      href: url,
      external: true,
    }, 'Anmelden'));
  });
});
